import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import Popover from '@mui/material/Popover'
import Typography from '@mui/material/Typography'
import AddIcon from '../AddIcon.svg'
import RemoveIcon from '../RemoveIcon.svg'
import Button from '@mui/material/Button'
import { updateReportsData } from '../reduxstore/actions'
import { updateBookmark, removeBookmark } from '../services/fetchreport'
import LoaderComponent from '../loaderComp/LoaderComponent'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import '../tableComponent/Table.scss'

export default function PopoverFavComponent(props: any) {
  const [ele, setEle] = useState<any>(null)
  const [isloading, setLoading] = useState(false)
  const [showAdd, setShowAdd] = useState(true)
  const reportList = useSelector((state: any) => state.reducers.reports)
  const userData = useSelector((state: any) => state.reducers.userInfo)

  const handleClick = (event: any) => {
    setEle(event.currentTarget)
  }
  const showToastRemoveSuccessMessage = () => {
    toast.success('Reports Bookmark removed successfully !', {
      position: 'top-right',
      toastId: 'addSuccess',
      autoClose: 2250
    })
  }
  const showToastRemoveErrorMessage = () => {
    toast.error('Report Bookmark not added. Please try again later !', {
      position: 'top-right',
      toastId: 'addError',
      autoClose: 2250
    })
  }
  const showToastAddSuccessMessage = () => {
    toast.success('Report Bookmark added successfully !', {
      position: 'top-right',
      toastId: 'addSuccess',
      autoClose: 2250
    })
  }
  const showToastAddErrorMessage = () => {
    toast.error('Report Bookmark not added. Please try again later !', {
      position: 'top-right',
      toastId: 'addError',
      autoClose: 2250
    })
  }
  const handleClose = () => {
    setEle(null)
  }
  const handlePostFavorites = async (e: any) => {
    setEle(e.currentTarget)
    setLoading(true)
    let report: any = ''
    const reportId = (e.target.parentElement.dataset.index ?? e.target.dataset.index)
    console.log('reportId', reportId)
    const userTypeName = props.userTypeName
    if (reportId) {
      report = reportList.filter((r: any) => ((r.reportId === reportId || r.reportName === reportId || r.customerName === reportId)) && (r.userTypeName === userTypeName))
    }
    const userDetails: any = {
      customerName: [ report[0].customerName ],
      reportName: report[0].reportName,
      reportNameDt: report[0].updatedDate,
      reportId: report[0].reportId,
      userRole: 'string',
      userType: report[0].userTypeName ? report[0].userTypeName : userData[0].userType,
      username: userData[0].userName,
      userEmailAddr: userData[0].userEmailAddr,
      encUserType: userData[0].encUserType,
      encUserName: userData[0].encUserName,
      encUserEmailAddr: userData[0].encUserEmailAddr,
      e_id: userData[0].e_id
    }
    const saveBookmarksResponse = await updateBookmark(userDetails)
    setLoading(false)
    if (JSON.stringify(saveBookmarksResponse) === '["Bookmark Saved"]') {
      showToastAddSuccessMessage()
      setShowAdd(false)
    } else {
      setLoading(false)
      showToastAddErrorMessage()
      setShowAdd(true)
    }
    handleClose()
  }
  const handleRemoveBookmarks = async (e: any) => {
    try {
      setLoading(true)
      let report: any = ''
      const reportId = (e.target.parentElement.dataset.index ?? e.target.dataset.index)
      const userTypeName = props.userTypeName
      if (reportId) {
        report = reportList.filter((r: any) => ((r.reportId === reportId || r.reportName === reportId || r.reportId === reportId) && (r.userTypeName === userTypeName)))
      }
      const userDetails: any = {
        customerName: [ 'string' ],
        reportName: report[0].reportName,
        reportNameDt: '',
        reportId: report[0].reportId,
        userRole: 'string',
        userType: report[0].userTypeName ? report[0].userTypeName : userData[0].userType,
        username: userData[0].userName,
        userEmailAddr: userData[0].userEmailAddr,
        encUserType: userData[0].encUserType,
        encUserName: userData[0].encUserName,
        encUserEmailAddr: userData[0].encUserEmailAddr,
        e_id: userData[0].e_id
      }
      const removeBookmarkResponse = await removeBookmark(userDetails)
      setLoading(false)
      if (JSON.stringify(removeBookmarkResponse) === '["Bookmark Removed"]') {
        showToastRemoveSuccessMessage()
        setShowAdd(true)
      } else {
        showToastRemoveErrorMessage()
        setShowAdd(false)
      }
      handleClose()
    } catch (error) {
      setLoading(false)
      handleClose()
      showToastRemoveErrorMessage()
    }
  }
  const open = Boolean(ele)
  const id = open ? 'simple-popover' : undefined
  return (
        <>
        {showAdd ? <div>{isloading && <LoaderComponent />}<Button onClick={handleClick}><AddIcon className={'action-link'} /></Button><Popover id={id} open={open} anchorEl={ele} onClose={handleClose} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} transformOrigin={{ vertical: 'top', horizontal: 'center' }} ><Typography ><button className={'view-history'} data-index={props.index} onClick={(e) => handlePostFavorites(e)}>Add as Bookmark</button>{ props.isAdmin && <button className={'delete-record'} data-index={props.index} >Delete</button> }</Typography></Popover></div> : <div>{isloading && <LoaderComponent />}<Button onClick={handleClick}><RemoveIcon className={'action-link'} /></Button><Popover id={id} open={open} anchorEl={ele} onClose={handleClose} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} transformOrigin={{ vertical: 'top', horizontal: 'center' }} ><Typography ><button className={'view-history'} data-index={props.index} onClick={(e) => { e.stopPropagation(); handleRemoveBookmarks(e) }}>Remove Bookmark</button>{ props.isAdmin && <button className={'delete-record'} data-index={props.index} >Delete</button> }</Typography></Popover></div>}</>
  )
}
